import { useEffect } from "react";
import { usdFormat } from "../Utility/usdFormat";
import { openDrawer } from "../Layout/Dawer/drawerSlice";
import { useAppDispatch, useAppSelector } from "../hooks";
import SellAThonCard from "../Features/SalesDep/Sales/SellAThonCard";
import Loading from "../Components/Loading";
import { Col, Container, Row } from "reactstrap";
import SalesGraphYTD from "../Components/Graphs/SalesGraphYTD";
import { monthlySales } from "../Features/SalesDep/Sales/SalesSlice";
import { getTodoList } from "../Features/SalesDep/To-Do List/TodoSlice";
import { Todo } from "../Types/Todo";
import TodoCard from "../Features/SalesDep/To-Do List/TodoCard";
import WelcomeModal from "../Features/Shared/Dashboard/Welcome Modal/WelcomeModal";
import { closeWelcomeModal, openWelcomeModal, selectWelcomeModalOpen } from "../Features/Shared/Dashboard/Welcome Modal/WelcomeUISlice";

type MonthItem = {
    monthSalesCY: number;
    monthSalesLY: number;
};

export type Data = {
    data: number[];
    data2: number[];
    label: string[];
};

const Dashboard = () => {
    const dispatch = useAppDispatch();
    const monthlyData: MonthItem[] = useAppSelector(monthlySales);
    const toDo = useAppSelector<Todo>(getTodoList);
    const notifications = useAppSelector((state) => state.notifications.pushNotifArr);
    const welcomeOpen = useAppSelector<boolean>(selectWelcomeModalOpen);
    const loading = useAppSelector((state) => state.bootstrap.loading);

    useEffect(() => {
        if (
            toDo?.orders?.length > 0 ||
            toDo?.bids?.length > 0 ||
            toDo?.orders?.length > 0 ||
            notifications.length > 0
        ) {
            dispatch(openWelcomeModal());
        };
    }, [toDo.orders, toDo.nudges, notifications.length]);

    const labels = monthlyData.map((_, index) => 
        String(index + 1)
    );
    
    const monthlySalesCY = monthlyData.map((item) => 
        Number(item.monthSalesCY)
    );

    const monthlySalesLY = monthlyData.map((item) =>
        Number(item.monthSalesLY)
    );

    const onClose = () => {
        dispatch(closeWelcomeModal());
    };

    if (loading) {
        return (
            <Loading />
        )
    }
    
    return (
        <div>
            <SellAThonCard />
            <Container className="my-5">
                <Row>
                    <Col>
                        <SalesGraphYTD 
                            data={monthlySalesCY} 
                            data2={monthlySalesLY}
                            labels={labels}
                        />
                    </Col>
                </Row>
                <Row className='my-5'>
                    <Col>
                        <TodoCard />
                    </Col>
                </Row>
                <WelcomeModal 
                    visible={welcomeOpen}
                    onClose={onClose}
                />
            </Container>
        </div>
    )
};

export default Dashboard;